import type { ReactNode } from 'react';

export const symbol_search_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m357-572 79-79q9-9 21-9t21 9q9 9 9 21t-9 21l-99 100q-9 9-21 9t-21-9l-55-54q-9-8-9-20.5t9-21.5q9-9 21-9t21 9l33 33Zm21 243q-108 0-183-75t-75-181q0-106 75-181t182-75q106 0 180.5 75T632-585q0 43-14 83t-42 75l242 240q9 9 9 22t-9 22q-9 9-22 9t-22-9L533-384q-30 26-70 40.5T378-329Zm-1-60q81 0 138-57.5T572-585q0-81-57-138.5T377-781q-82 0-139.5 57.5T180-585q0 81 57.5 138.5T377-389Z"
		/>
	</svg>
);
